import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { Card, CardContent } from '@/components/ui/card';
import { Neutrals } from '@/constants/theme';

export interface GroceryListEmptyStateProps {
  children?: React.ReactNode;
}

export function GroceryListEmptyState({ children }: GroceryListEmptyStateProps) {
  return (
    <View style={styles.emptyStateWrapper}>
      <Card style={styles.emptyCard}>
        <CardContent style={styles.emptyCardContent}>
          <View style={styles.emptyIcon}>
            <Ionicons name="cart-outline" size={32} color={Neutrals.textMuted} />
          </View>
          <Text style={styles.emptyCardText}>Your list is empty</Text>
          {children && <View style={styles.emptyCardInputRow}>{children}</View>}
        </CardContent>
      </Card>
    </View>
  );
}

const styles = StyleSheet.create({
  emptyStateWrapper: {
    minHeight: 280,
    width: '100%',
  },
  emptyCard: {
    marginBottom: 16,
    backgroundColor: Neutrals.whiteFaded85,
    borderRadius: 20,
    overflow: 'hidden',
  },
  emptyCardContent: {
    paddingVertical: 48,
    alignItems: 'center',
  },
  emptyIcon: {
    width: 64,
    height: 64,
    borderRadius: 16,
    backgroundColor: Neutrals.surface,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
  },
  emptyCardText: {
    fontSize: 14,
    color: Neutrals.textSecondary,
    marginBottom: 16,
  },
  emptyCardInputRow: {
    alignSelf: 'stretch',
    width: '100%',
  },
});
